import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API, auth } from "./membershipApi";
import { AreaUpsell } from "./AreaUpsell";

// Route gate for Golf / Gym tracks: members play everything; Core members keep one free taster track.
export const AreaGate = ({ area, children }) => {
  const { trackId } = useParams();
  const [s, setS] = useState(null);
  const [st, setSt] = useState(null);
  useEffect(() => {
    setS(null);
    axios.post(`${API}/api/membership/taster`, { area, track_id: trackId || "landing" }, auth())
      .then((r) => setS(r.data)).catch(() => setS({ allowed: false }));
    axios.get(`${API}/api/membership/state`, auth()).then((r) => setSt(r.data)).catch(() => {});
  }, [area, trackId]);
  if (!s) return <div className="flex min-h-screen items-center justify-center bg-[#0f1412]"><Loader2 className="animate-spin text-[#d7bb7a]" /></div>;
  if (s.allowed) return children;
  const a = st?.areas?.[area];
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0f1412] px-5" data-testid={`area-gate-${area}`}>
      <div>
        <p className="mb-5 text-center text-sm text-[#b9ad8f]" data-testid="area-gate-taster-note">You've had your free taster. Upgrade to open every track.</p>
        <AreaUpsell area={area} price={a?.price || 9.99} core={st?.core_price || 6.99} onDone={() => window.location.reload()} />
      </div>
    </div>
  );
};
